import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Aditya Ranjan </span>
            from <span className="purple"> Delhi, India.</span>
            <br />
            I am currently employed a B.tech student.
            <br />
            I am pursuing my bachelors from Bharati Vidyapeeth.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Food
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Keep on it, until it happens!"{" "}
          </p>
          <footer className="blockquote-footer">Ranjan</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
